// Native playback, scoped to visible scenes. No new animation clock.
const text=window.TapveroCommerceConfig.messages;
const films=[...document.querySelectorAll('.tap-film,.gallery-film')];
// Transformed, layered carousel images can miss native lazy-load visibility tests.
// Load the five-image group together only as the carousel approaches the viewport.
const fan=document.querySelector('.fan-viewport');
if(fan){const fanImages=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){fan.querySelectorAll('img').forEach(img=>{img.loading='eager';});fanImages.disconnect();}},{rootMargin:'500px'});fanImages.observe(fan);}
const reduced=matchMedia('(prefers-reduced-motion:reduce)');
const connection=navigator.connection;
const seen=new Map(),userPaused=new WeakSet(),internalPause=new WeakSet();
let raf=0;
const motionOff=()=>reduced.matches||document.documentElement.classList.contains('motion-off');
function sync(){
  raf=0;
  for(const video of films){
    const panel=video.closest('.stack-panel');
    const active=!panel||panel.dataset.active==='true';
    const mayPlay=seen.get(video)&&active&&!motionOff()&&!document.hidden&&!userPaused.has(video);
    if(mayPlay&&!connection?.saveData&&video.paused){video.play().catch(()=>{});}
    if(!mayPlay&&!video.paused){internalPause.add(video);video.pause();}
  }
}
function schedule(){if(!raf)raf=requestAnimationFrame(sync);}
const observer=new IntersectionObserver(entries=>{for(const e of entries)seen.set(e.target,e.isIntersecting&&e.intersectionRatio>.35);schedule();},{threshold:[0,.35,.6]});
films.forEach(video=>{
  const control=video.parentElement.querySelector('[data-film-control]');
  const paintControl=()=>{if(!control)return;control.textContent=video.paused?text.play_video_html:text.pause_video_html;control.setAttribute('aria-label',control.textContent);};
  control?.addEventListener('click',()=>{if(video.paused){userPaused.delete(video);video.play().catch(paintControl);}else{userPaused.add(video);video.pause();}paintControl();});
  video.addEventListener('play',paintControl);video.addEventListener('pause',paintControl);paintControl();
  observer.observe(video);
  video.addEventListener('pause',()=>{if(internalPause.has(video)){internalPause.delete(video);return;}userPaused.add(video);});
  video.addEventListener('play',()=>userPaused.delete(video));
});
addEventListener('scroll',schedule,{passive:true});
addEventListener('tapvero:motion',schedule);
addEventListener('tapvero:stackchange',schedule);
document.addEventListener('visibilitychange',schedule);
reduced.addEventListener('change',schedule);
connection?.addEventListener?.('change',schedule);
schedule();
